import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ToastProps, toast } from '../components/toast';

type CopiedValue = string | null;

type CopyFn = (text: string) => Promise<boolean>;

export function useCopyToClipboard(
  customSuccessTitle?: Partial<Pick<ToastProps, 'description' | 'title'>>,
): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);
  const { t } = useTranslation();

  const copy: CopyFn = useCallback(
    async (text) => {
      if (!navigator?.clipboard) {
        console.warn('Clipboard not supported');
        return false;
      }

      try {
        await navigator.clipboard.writeText(text);
        setCopiedText(text);
        toast({
          description: customSuccessTitle?.description ?? t('copied_description', { value: text }),
          title: customSuccessTitle?.title ?? t('copied'),
        });
        return true;
      } catch (error) {
        console.warn('Copy failed', error);
        setCopiedText(null);
        return false;
      }
    },
    [customSuccessTitle, t],
  );

  return [copiedText, copy];
}
